import PropTypes from 'prop-types';
import React from 'react';

import Sanitize from '@/src/shared/components/Sanitize';
import Table from '@/src/shared/components/Table';

function ProvisionsTable({ provisions }) {
  return (
    <Table
      size="small"
      columns={[
        {
          title: 'Topic',
          dataIndex: 'TopicForLitStateSnapshot',
        },
        {
          title: 'Details',
          dataIndex: 'TopicDescription',
          render: value => <Sanitize>{value}</Sanitize>,
        },
      ]}
      dataSource={provisions}
      pagination={false}
    />
  );
}

ProvisionsTable.propTypes = {
  provisions: PropTypes.arrayOf(
    PropTypes.shape({
      ChartId: PropTypes.number,
      ChartTitle: PropTypes.string,
      TopicId: PropTypes.number,
      TopicDescription: PropTypes.string,
      IncludeForLitStateSnapshot: PropTypes.string,
      TopicForLitStateSnapshot: PropTypes.string,
      DateLastModified: PropTypes.string,
      SortOrder: PropTypes.number,
    })
  ).isRequired,
};

export default ProvisionsTable;
